import React from 'react';
import { combineReducers } from '@reduxjs/toolkit';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'commons/src/highchartsGlobalConfig';
import NotSupported from 'commons/src/components/errorComponents/NotSupported';
import IntlWrapper from 'commons/src/i18n/IntlWrapper';
import configureStore from 'commons/src/store/configureStore';
import { initialize } from './actions';
import Error from './components/error';
import 'commons/src/style/index.scss';
import './styles/index.scss';
import Footer from './components/footer/Footer';
import { publicDashboardUrl } from './constants';
import PublicDashboardView from './features/publicDashboard/PublicDashboardView';
import PublicDeviceView from './features/publicDevice/PublicDeviceView';
import VideoCallLiveData from './features/VideoCallLiveData/VideoCallLiveData';
import YugeView from './features/yugeViewCES/yugeView';
import publicReducers from './reducers';
import sagas from './sagas';

const rootReducer = combineReducers(publicReducers);
export type RootReducer = typeof rootReducer;
const store = configureStore(rootReducer, sagas);
export type RootState = typeof store;
const getStore = (): RootState => {
    store.dispatch(initialize());
    return store;
};

const App = (): React.ReactElement => (
    <Provider store={getStore()}>
        <IntlWrapper>
            <>
                <BrowserRouter>
                    <div id="publicPage" className="public-wrapper">
                        <Routes>
                            <Route path=":serialNumber" element={<PublicDeviceView />} />
                            <Route path="yuge-view/:serialNumber" element={<YugeView />} />
                            <Route path="meeting-background/:serialNumber" element={<VideoCallLiveData />} />
                            <Route path={`${publicDashboardUrl}/:dashboardId`} element={<PublicDashboardView />} />
                            <Route path="404" element={<Error />} />
                            <Route path="not_supported" element={<NotSupported />} />
                        </Routes>
                    </div>
                </BrowserRouter>
                <Footer />
            </>
        </IntlWrapper>
    </Provider>
);

createRoot(document.getElementById('root') as HTMLElement).render(<App />);

export default App;
